import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'


export const _VerticalTimeline = styled.div`
  * {
    box-sizing: border-box;
  }
  width: 100%;
  position: relative;
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    &:before {
      display: none;
    }
  }
  @media screen and (max-width: 767px) {
    padding-right: 0px;
  }
`
